// src/hooks/useDrivers.js
import { useEffect, useState } from 'react';
import { getDrivers } from '../api/drivers';

export default function useDrivers() {
  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(true);

  const refreshDrivers = async () => {
    setLoading(true);
    try {
      const data = await getDrivers();
      setDrivers(data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refreshDrivers();
  }, []);

  return { drivers, loading, refreshDrivers };
}
